import { useQuery } from "@tanstack/react-query";
import { apiJson } from "@/lib/api-client";

export interface OverviewPnl {
  total_pnl: number;
  funding_total: number;
  trade_count: number;
}

export interface UnpairedTrade {
  id: number;
  grid_id: string;
  side: "buy" | "sell";
  price: number;
  quantity: number;
  fee: number | null;
}

export interface WindActiveItem {
  session: { id: string; symbol: string };
  latest_cycle: {
    status: string;
    entry_price: number | null;
    direction: "long" | "short";
    quantity: number;
    entry_fee: number | null;
  } | null;
  total_pnl: number;
}

export interface Vol24h {
  volume: number;
  trades: number;
  pnl: number;
  fees: number;
}

export interface OverviewData {
  // Backend returns full GridConfig from getActiveGrids(); symbol is needed so
  // the overview can map unpaired.grid_id → live price for unrealized PnL.
  grids: { id: string; symbol: string }[];
  pnl: OverviewPnl;
  unpaired: UnpairedTrade[];
  volatility: Record<string, unknown>;
  wind_active: WindActiveItem[];
  vol_24h: Vol24h;
}

export function useOverview() {
  return useQuery<OverviewData>({
    queryKey: ["overview"],
    queryFn: () => apiJson<OverviewData>("/overview"),
    // SSE /events pushes invalidation on writes; this poll is a safety net
    // for missed events (reconnect races, bot restart while tab backgrounded).
    refetchInterval: 30_000,
  });
}
